module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../biz-b2c-web-h5/config/loader/esbuild-loader/esbuild-loader.js!../../../../../../biz-b2c-web-h5/config/loader/esbuild-loader/esbuild-loader.js!../../../../../../biz-b2c-web-h5/config/loader/lodash-cherry-pick-loader.js!../../../../../../biz-b2c-web-h5/config/loader/yofo-cherry-pick-loader.js??ref--1-0!./index.tsx"));
	}, "ShowCaseView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ShowCaseView!../biz-micro-services-ui/project/middlePlatform/pages/dreamPlan/showCase/index.tsx
// module id = 1086
// module chunks = 438